import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card card-gray p-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-2" }
const _hoisted_4 = { class: "form-label" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = { class: "form-label" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = { class: "form-label" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "form-label" }
const _hoisted_13 = { class: "col-md-2 btn-erase-reconstruction d-flex" }
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 0,
  class: "invalid-feedback d-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('reconstructions.type')) + ": ", 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event)),
          class: "form-select custom-select mb-0"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptions, (option) => {
            return (_openBlock(), _createElementBlock("option", { value: option }, _toDisplayString(_ctx.$t('reconstructions.types.' + option)), 9, _hoisted_5))
          }), 256))
        ], 512), [
          [_vModelSelect, _ctx.type]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('reconstructions.year')) + ": ", 1),
        _withDirectives(_createElementVNode("input", {
          class: "form-control mb-0",
          type: "number",
          min: "1",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.year) = $event))
        }, null, 512), [
          [_vModelText, _ctx.year]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('reconstructions.extent')) + ": ", 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.extent) = $event)),
          class: "form-select custom-select mb-0"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extentOptions, (option) => {
            return (_openBlock(), _createElementBlock("option", { value: option }, _toDisplayString(_ctx.$t('reconstructions.extents.' + option)), 9, _hoisted_10))
          }), 256))
        ], 512), [
          [_vModelSelect, _ctx.extent]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('reconstructions.description')) + ": ", 1),
        _withDirectives(_createElementVNode("input", {
          class: "form-control w-100 mb-0",
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event))
        }, null, 512), [
          [_vModelText, _ctx.description]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeReconstruction(_ctx.value))),
          class: "btn btn-outline-secondary mt-auto",
          title: _ctx.$t('form.buttonRemove')
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("span", { class: "fas fa-times" }, null, -1)
        ]))], 8, _hoisted_14)
      ])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}